import React from 'react'
import { CloseCircleOutlined } from '@ant-design/icons';
import { useFeiyongDelSHMutation } from '../../store/NeiZhangFeiYongApi';
import { App  } from 'antd';
function ExpenseAuditCancle(props) {
    const {message,modal} = App.useApp()
    const [submitDel] = useFeiyongDelSHMutation();
    return (
       <a onClick={() => {
                modal.confirm({
                        title: '取消审核费用',
                        content: '你确定要取消审核这条记录吗？取消审核后的费用可以修改和删除',
                        okText: '确定',
                        cancelText: '取消', 
                        onOk: () => {
                            submitDel({
                                fysh_fy_id: props.fy_id,
                                fysh_uid:props.eu_id,
                            }).then((res) => {
                                if (res.data.Status === 'success') {
                                    message.success('取消审核成功！');
                                }
                                if (res.data.Status === "fail") {
                                    modal.warning({
                                        title: '该费用报销单不需取消审核！',
                                        content: '没有审核数据',
                                    });
                                }
                            })
                        },
                    });                 
                }}><CloseCircleOutlined /> 取消审核</a>
    )
}

export default ExpenseAuditCancle